import React, { useState, useEffect, useRef } from "react";
import './Style/common.css';
import './Style/header.css';
import "./Style/MyCompsPast.css";
import './Style/trophy_club.css';
import Loading from "../../Common/Loading";
// import trophy_club_0 from './Image/trophy_club/trophy_club_0.png';
import Header from "../../Common/Header";
import Section from "../../Common/Section";
import CryptoJS from "crypto-js";

const SECRET_ENCRYPTION_KEY="6GJZIa6J7NZzTdzf4K7Em6y6XiqwT09wqkKkNHaAvjE=";

function decrypt(encryptedBase64: string) {
  try {
    const key = CryptoJS.enc.Base64.parse(SECRET_ENCRYPTION_KEY);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return {};
  }
}

const MyCompsPast: React.FC = () => {
    const [
      // userName
      , setUserName] = useState<string>("");
    const [
      // imageSrc
      , setImageSrc] = useState('');
    const [comps, setComps] = useState<Comp[]>([]);
    const [loading, setLoading] = useState(true);
          const [showBackToTop, setShowBackToTop] = useState(false);
    const [showBackToBottom, setShowBackToBottom] = useState(true);
    const scrollContainerRef = useRef<HTMLElement | null>(null);

      interface Comp {
        CompsTitle: string;
        CompsImageLink: string | null;
        UserName: string;
        DrawDate: string | null;
      }

const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;


   const findScrollContainer = (): HTMLElement => {
      const candidates: (HTMLElement | null)[] = [
        (document.scrollingElement as HTMLElement) || null,
        document.getElementById("contents_math"),
        document.getElementById("main_top_container"),
        document.getElementById("contents_english"),
        document.getElementById("contents_physics"),
        document.getElementById("contents_chemistry"),
        document.getElementById("contents_biology"),
        document.body,
        document.documentElement,
      ];

      for (const el of candidates) {
        if (!el) continue;
        try {
          const style = window.getComputedStyle(el);
          const overflowY = style.overflowY;
          if (el.scrollHeight > el.clientHeight && (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay" || overflowY === "visible")) {
            return el;
          }
        } catch (e) {
        }
      }
      return (document.scrollingElement as HTMLElement) || document.documentElement;
    };

    // detect and store the scroll container so click handlers can scroll the same element
    scrollContainerRef.current = findScrollContainer();
    const registeredContainer = scrollContainerRef.current;

    const handleScroll = () => {
      const el = (scrollContainerRef.current || registeredContainer || (document.scrollingElement as HTMLElement) || document.documentElement) as HTMLElement;
      const scrollTop = el.scrollTop;
      const innerH = el.clientHeight || window.innerHeight;
      const scrollHeight = el.scrollHeight;

      const scrollable = Math.max(0, scrollHeight - innerH);
      const TOL = 6;
      const atTop = scrollTop <= TOL;
      const atBottom = scrollTop >= Math.max(0, scrollable - TOL);
      const ratio = scrollable <= 0 ? 0 : scrollTop / scrollable;

      if (atTop) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
        return;
      }

      if (atBottom) {
        setShowBackToTop(true);
        setShowBackToBottom(false);
        return;
      }

      if (ratio < 0.5) {
        setShowBackToBottom(true);
        setShowBackToTop(false);
      } else {
        setShowBackToTop(true);
        setShowBackToBottom(false);
      }
    };
     try {
      if (registeredContainer) {
        registeredContainer.addEventListener("scroll", handleScroll, { passive: true });
      } else {
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
    } catch (e) {
      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    // run once to set initial state
    setTimeout(handleScroll, 0);
useEffect(() => {
  setLoading(true);

  fetch(`${apiUrl}MyCompsPast/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      FamilyCode: sessionStorage.getItem("FamilyCode"),
      SchoolCode: sessionStorage.getItem("SchoolCode"),
      Login: sessionStorage.getItem("Login"),
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      const decryptedData = decrypt(data.data);

      if (Array.isArray(decryptedData)) {
        setComps(decryptedData);
      } else {
        console.warn("Unexpected decrypted data shape", decryptedData);
        setComps([]);
      }
    })
    .catch((err) => {
      // console.error("Fetch error:", err);
      setComps([]);
    })
    .finally(() => setLoading(false));

  const UserName = sessionStorage.getItem("FName");
  const UserAvatar = sessionStorage.getItem("CurrentAvatar");

  if (UserName) setUserName(UserName);

  try {
    if (UserAvatar) setImageSrc(UserAvatar);
  } catch (error) {
    console.error("Error loading image:", error);
  }

  document.body.classList.add("StudyRoom-background");

  return () => {
    document.body.classList.remove("StudyRoom-background");
  };
}, [apiUrl]);


      // const handleTrophyClick = () => {
      //   const trophyClubLegend = document.getElementById("trophy_club_legend");
      //   if (trophyClubLegend) {
      //     trophyClubLegend.style.display = 
      //       trophyClubLegend.style.display === "none" ? "block" : "none";
      //   }
      // };



  return (
    <form>
      {/* <a href="/STUDENT/MSR/MyCompsPast" className="back-to-top">Back to Top</a>
      <a href="/STUDENT/MSR/MyCompsPast" className="back-to-bottom" id="back_to_bottom_link">Back to Top</a> */}

        <div id="main_top_container">
            <Header />
                                            <a
          href="#bottom"
          className="back-to-bottom"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = (container as any).scrollHeight;
              (document.body as any).scrollTop = document.body.scrollHeight;
            }, 400);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = (container as any).scrollHeight;
                (document.body as any).scrollTop = document.body.scrollHeight;
              }, 400);
            }
          }}
          aria-label="Back to bottom"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToBottom ? 1 : 0,
            transform: showBackToBottom ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToBottom ? 'auto' : 'none',
            position: 'fixed',
            left: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',

       
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Bottom
        </a>

        <a
          href="#top"
          className="back-to-top"
          onClick={(e) => {
            e.preventDefault();
            const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
            try {
              container.scrollTo({ top: 0, behavior: 'smooth' });
            } catch {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setTimeout(() => {
              (container as any).scrollTop = 0;
              (document.body as any).scrollTop = 0;
            }, 300);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              const container = scrollContainerRef.current || (document.scrollingElement as HTMLElement) || document.documentElement;
              try {
                container.scrollTo({ top: 0, behavior: 'smooth' });
              } catch {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              setTimeout(() => {
                (container as any).scrollTop = 0;
                (document.body as any).scrollTop = 0;
              }, 300);
            }
          }}
          aria-label="Back to top"
          role="button"
          tabIndex={0}
          style={{
            opacity: showBackToTop ? 1 : 0,
            transform: showBackToTop ? 'translateY(0)' : 'translateY(8px)',
            display: 'block',
            cursor: 'pointer',
            zIndex: 2147483647,
            pointerEvents: showBackToTop ? 'auto' : 'none',
            position: 'fixed',
            right: 20,
            bottom: 20,
            transition: 'opacity 240ms ease, transform 240ms ease',
            boxShadow: '0 6px 14px rgba(0,0,0,0.18)'
          }}
        >
          Back to Top
        </a>
            <Section />

            <div id="mi_banner" className="subject_banner">
                <div id="mi_banner_text_img"></div>
            </div>

            <div id="mi_page_btn_container">
                <div id="mi_page_btn_store" className="mi_page_btn">
                    <a id="hlinkStore" href="/STUDENT/MSR/MyStore" >Store</a></div>
                            <div id="mi_page_btn_avatars" className="mi_page_btn">
                    <a id="hlinkMyIncentives" href="/STUDENT/MSR/MyIncentives" >Avatars</a></div>
                <div id="mi_page_btn_comp" className="mi_page_btn mi_page_btn_selected">
                    <a href="/STUDENT/MSR/MyCompsCurrent">Comps</a></div>            
                <div id="mi_page_btn_purchase" className="mi_page_btn mi_page_btn_last">
                    <a id="hlinkPurchases" href="/STUDENT/MSR/AllPurchases" >Purchases</a></div>
            </div>

            <div id="mi_page_comps_current" className="contents section_container mi_page_bg">
                <div id="mi_comps_current_container" className="section_div">
                    <div id="mi_comps_toggle_row">
                        <div id="mi_comps_toggle_container">
                            <div className="mi_comps_toggle_button mi_comps_toggle_button_clear">
                                <a  href="/STUDENT/MSR/MyCompsCurrent">Current Comps</a></div>
                            <div className="mi_comps_toggle_button ">
                                <a id="hlinkPastComps" href="/STUDENT/MSR/MyCompsPast" >Past Comps</a></div>
                        </div>
                    </div>
                      {loading ? (
                        < Loading />
                      ) : (
                        comps.map((comp, i) => (
                          <div className="mi_comps_single_box mi_comps_single_box_expand" key={i}>
                            <div className="mi_comps_single_box_image">
                              <div
                                id={`mi_comps_single_box_image_${i}`}
                                className="mi_comps_single_box_image"
                                style={{
                                  backgroundImage: `url(${comp.CompsImageLink || "/images/placeholder.png"})`,
                                }}
                                title={comp.CompsTitle}
                              />
                              {/* <div className="mi_comps_single_box_right_container"> */}
                                <p className="mi_comps_single_box_right_title">{comp.CompsTitle}</p>
                                <p className="mi_comps_single_box_right_entry_ended">
                                  Draw date: {comp.DrawDate || "—"}
                                </p>
                                <p className="mi_comps_single_box_right_winner">Congratulations</p>
                                <p className="mi_comps_single_box_right_winner_name">{comp.UserName}</p>
                              {/* </div> */}
                            </div>
                          </div>
                        ))
                      )}

                    <div className="subject_middle_gap"></div>
                    <div className="subject_bottom_gap"></div>
                </div>
            </div>
          </div>
      
    </form>
  );
};

export default MyCompsPast;